export default "__VITE_ASSET__Dwq_X6ja__"